<div class="row eip-pt-20 eip-pt-xs-0">
  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
      <EIPAutoComplete ShowTextValueField='N' TextField="group_Name"  ValueField="group_Id" WaterMarkText="Organization" [dataSource]='businessGrpList' setId="ddBusinessGrpId" (valueChange)='onchangeBusinessGroup($event)' [IsCascading]='true'>
      </EIPAutoComplete>
  </div>
  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
      <EIPMultiSelectAutoComplete [dataSource]="moduleList" setId="ddmoduleid" TextField="cedDescription" ValueField="cedId" WaterMarkText="Module" ShowTextValueField='N'  #CheckTest (valueChange)="onchangeModule($event)">
      </EIPMultiSelectAutoComplete>
  </div>
  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
      <EIPAutoComplete ShowTextValueField='N' TextField="elementDescription"  ValueField="elementId" WaterMarkText="Element" [dataSource]='elementList' setId="ddelementid" (valueChange)='onchangeElement($event)' [defaultValue]='' [SingleValueBind]="false" [IsCascading]='true'>
      </EIPAutoComplete>
  </div>
  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
      <EIPMultiSelectAutoComplete [dataSource]="disciplineList" setId="ddDiscpId" TextField="text" ValueField="value" WaterMarkText="Element Detail" ShowTextValueField='N'  #CheckTest (valueChange)="onchangeEleDetail($event)">
      </EIPMultiSelectAutoComplete>
  </div>
</div>
<div class="row">
  <div class="col-md-12 d-none d-md-block  eip-mb-15">
      <hr>
  </div>
  <div style="width :80%; margin:0% auto">
      <div>
          <div class="row">
              <div class="col-xl-5 col-lg-5 col-md-5 col-sm-8 col-xs-14">
                  <kendo-grid [skip]="skip" [data]="cartDataSource" [height]="500" [pageable]="false" [sortable]="true" [resizable]="true" [reorderable]="true" [scrollable]="true" class="form-group-grid auto-complete-equal kg-hover-icon" (cellClick)="rightcellClickHandler($event)">
                      <ng-template kendoGridToolbarTemplate>
                          <div>
                              <input placeholder="Search Member..." style="width: 100%;margin-top: 1%;" kendoTextBox (input)="onFilterRS($event.target.value)" #searchLeftName />
                          </div>
                      </ng-template>
                      <kendo-grid-column title="MemberName" width="150">
                          <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                              <span><input type="checkbox" [(ngModel)]="allRowsSelected" (change)="OnClickRightSideHeaderCheckbox($event,dataItem)"></span>
                              <span style="margin-left: 3%;">MemberName</span>
                          </ng-template>
                          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                              <span><input type="checkbox" [checked]="dataItem.isCheck" (change)="OnClickRightSideRowCheckbox($event,dataItem)"></span>
                              <span style="margin-left: 3%;">{{dataItem.text}}</span>
                          </ng-template>
                      </kendo-grid-column>
                  </kendo-grid>
              </div>
              <div class="col-xl-1 col-lg-1 col-md-1 col-sm-3 col-xs-6">
                  <div style="width:100%;margin-top: 68%;padding-top: 40%;display: inline-block;">
                      <div style="margin-top: 50%;padding-top: 59%;font-size: 35px;">
                          <i style="margin-left:32%" class="fas fa-angle-double-right" (click)="rightSideMoveMember()" aria-hidden="true"></i>
                      </div>
                      <div style="margin-top: 3%;padding-top: 3%;">
                          <i style="font-size: 36px;margin-left: 30%;" class="fas fa-angle-double-left" (click)="leftSideMoveMember()" aria-hidden="true"></i>
                      </div>
                  </div>
              </div>
              <div class="col-xl-5 col-lg-5 col-md-5 col-sm-8 col-xs-14">
                  <kendo-grid [data]="cartSelectedData" [skip]="skip" [sortable]="true" [reorderable]="true" [scrollable]="true" [height]="510" (cellClick)="leftSidecellClickHandler($event)">
                      <ng-template kendoGridToolbarTemplate>
                          <div>
                              <input placeholder="Search Member..." style="width: 100%;margin-top: 1%;" kendoTextBox (input)="onFilterLS($event.target.value)" #searchRightName />
                          </div>
                      </ng-template>
                      <kendo-grid-column>
                          <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                              <span><input type="checkbox" [(ngModel)]="allRowsLeftSelected" (change)="OnClickLeftSideHeaderCheckbox($event,dataItem)"></span>
                              <span style="margin-left: 3%;">Selected MemberName </span>
                          </ng-template>
                          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                              <span><input type="checkbox" [checked]="dataItem.isCheck" (change)="OnClickLeftSideRowCheckbox($event,dataItem)"></span>
                              <span style="margin-left: 3%;">{{dataItem.text}} </span>
                          </ng-template>
                      </kendo-grid-column>
                  </kendo-grid>
              </div>
          </div>
      </div>
  </div>
</div>